import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useGetAdminDashboardData } from '@/hooks/api/use-get-admin-dashboard-data';
import { useUserProfile } from '@/states/user-profile';

import { FetchStates } from '@/components/fetch-states';
import { TimeRangeSelector } from '@/components/time-range-selector';
import { Section } from '@/components/content-layout/section';
import { SectionHeader } from '@/components/content-layout/section-header';

import { CaseFiltersProps, Filters } from './filters';
import { CaseChart } from './chart';

export function CasesChartPage() {
  const { profile } = useUserProfile();
  const isVitaziAdmin = profile.role === 'vitaziadmin';

  const [time, setTime] = useState<'day' | 'week' | 'month' | 'custom'>('week');
  const [dateRange, setDateRange] = useState({ start: new Date(), end: new Date() });
  const [filters, setFilters] = useState<CaseFiltersProps['filters']>({ site: 'not-specified' });

  const { data: cases, loading, refetchCases } = useGetAdminDashboardData({ dateRange, filters });

  const { t } = useTranslation();

  useEffect(() => {
    if (profile.clinic) {
      setFilters((filter) => ({ ...filter, clinic: profile.clinic }));
    }
  }, [profile.clinic]);

  return (
    <Section>
      <SectionHeader title={t('admin-dashboard-title')} element="h1" />
      <div className="flex justify-between gap-4">
        <TimeRangeSelector
          value={time}
          onChange={setTime}
          onDateChange={(start, end) => setDateRange({ start, end })}
        />
        <Filters filters={filters} onChange={setFilters} isVitaziAdmin={isVitaziAdmin} />
      </div>
      <FetchStates loading={loading} refetch={refetchCases} empty={!cases?.length}>
        <div className="h-[500px]">
          <CaseChart data={cases} />
        </div>
      </FetchStates>
    </Section>
  );
}
